import { ExamType } from '../../api/exam';
import Segment from '../shared/segment';
import Field from '../shared/field';
import NavLink from '../shared/buttons/nav-link';

export type ExamPropsType = {
  exam: ExamType;
};

function Exam({ exam }: ExamPropsType) {
  return (
    <Segment hoverable color='blue' className='grid items-center gap-2 text-center sm:grid-cols-4'>
      <p className='font-bold'>{exam.name}</p>
      <Field title='تعداد سوالات' content={exam.questionCount} />
      <Field title='زمان آزمون' content={`${exam.duration} دقیقه`} />
      <NavLink to={`/exams/${exam.id}/info`} content='جزئیات آزمون' className='mx-auto my-2' />
    </Segment>
  );
}

export default Exam;
